// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media all and (max-width: 768px) {
  .pagination-wrapper {
    flex-direction: column;
  }
  .pagination-wrapper .entry-number label {
    margin-bottom: 15px;
  }
  .wrapper-push-notification .left-section, .wrapper-push-notification .right-section {
    width: 100%;
  }
  .wrapper-push-notification .left-section {
    margin-bottom: 15px;
  }
  #cx-main {
    margin-left: 60px;
    padding: 75px 15px 15px 15px;
  }
  .dashboard-main .dashboard-wrapper .right-section {
    width: 100%;
  }
  .dashboard-main .dashboard-wrapper .left-section {
    margin-bottom: 15px;
    width: 100%;
  }
  .order-select-input button {
    margin-top: 15px;
  }
  .heading-common label {
    font-size: 18px;
  }
  table.dataTable.no-footer {
    margin-top: 20px;
  }
  .dataTables_wrapper .dataTables_length select {
    width: auto;
  }
  .cx-header .cx-header-wrapper header .left img {
    height: 40px;
    width: 40px;
  }
  .cx-header .cx-header-wrapper header .left span {
    font-size: 18px;
  }
  .main-login .wrapper .left .logo {
    height: 20vh;
  }
  .main-login .wrapper .left .logo img {
    height: 15vh;
  }
  .main-login .wrapper .right {
    height: 80vh;
  }
}
@media all and (max-width: 480px) {
  .order-select-input button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/responsive.scss"],"names":[],"mappings":"AAEA;EACE;IACE,sBAAA;EADF;EAGA;IACE,mBAAA;EADF;EAGA;IACE,WAAA;EADF;EAGA;IACE,mBAAA;EADF;EAGA;IACE,iBAAA;IACA,4BAAA;EADF;EAGA;IACE,WAAA;EADF;EAGA;IACE,mBAAA;IACA,WAAA;EADF;EAGA;IACE,gBAAA;EADF;EAGA;IACE,eAAA;EADF;EAGA;IACE,gBAAA;EADF;EAGA;IACE,WAAA;EADF;EAGA;IACE,YAAA;IACA,WAAA;EADF;EAGA;IACE,eAAA;EADF;EAGA;IACE,YAAA;EADF;EAEE;IACE,YAAA;EAAJ;EAGA;IACE,YAAA;EADF;AACF;AAGA;EACE;IACE,WAAA;EADF;AACF","sourcesContent":["@media all and (max-width: 991px) {\n}\n@media all and (max-width: 768px) {\n  .pagination-wrapper{\n    flex-direction: column;\n  }\n  .pagination-wrapper .entry-number label{\n    margin-bottom: 15px;\n  }\n  .wrapper-push-notification .left-section, .wrapper-push-notification .right-section{\n    width: 100%;\n  }\n  .wrapper-push-notification .left-section{\n    margin-bottom: 15px;\n  }\n  #cx-main{\n    margin-left: 60px;\n    padding: 75px 15px 15px 15px;\n  }\n  .dashboard-main .dashboard-wrapper .right-section{\n    width: 100%;\n  }\n  .dashboard-main .dashboard-wrapper .left-section{\n    margin-bottom: 15px;\n    width: 100%;\n  }\n  .order-select-input button {\n    margin-top: 15px;\n  }\n  .heading-common label {\n    font-size: 18px;\n  }\n  table.dataTable.no-footer {\n    margin-top: 20px;\n  }\n  .dataTables_wrapper .dataTables_length select {\n    width: auto;\n  }\n  .cx-header .cx-header-wrapper header .left img {\n    height: 40px;\n    width: 40px;\n  }\n  .cx-header .cx-header-wrapper header .left span {\n    font-size: 18px;\n  }\n  .main-login .wrapper .left .logo {\n    height: 20vh;\n    img {\n      height: 15vh;\n    }\n  }\n  .main-login .wrapper .right {\n    height: 80vh;\n  }\n}\n@media all and (max-width: 480px) {\n  .order-select-input button {\n    width: 100%;\n  }\n}\n@media all and (max-width: 360px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
